import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalBar } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import 'chartjs-plugin-datalabels';

function ChartHorizontalBars(props) {
  const { data, options, width, height, legend } = props;

  return (
    <HorizontalBar
      legend={legend}
      data={data}
      options={options}
      height={height}
      width={width}
    />
  );
}

ChartHorizontalBars.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(PropTypes.shape),
  }).isRequired,
  options: PropTypes.shape(PropTypes.shape),
  height: PropTypes.number,
  width: PropTypes.number,
  legend: PropTypes.shape({
    display: PropTypes.bool,
  }),
};

ChartHorizontalBars.defaultProps = {
  options: {},
  height: 300,
  width: 300,
  legend: {
    display: true,
  },
};

export default withTranslation('common')(ChartHorizontalBars);
